import LeadsPagination from './LeadsPagination'

export default LeadsPagination
